// extracted by mini-css-extract-plugin
export var active = "styles-module--active--8799d";
export var arrowButton = "styles-module--arrowButton--6e065";
export var arrowIcon = "styles-module--arrowIcon--53953";
export var controls = "styles-module--controls--d1e97";
export var pagination = "styles-module--pagination--55a06";
export var paginationDot = "styles-module--paginationDot--00f8b";